// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"118":"b8a0ded3","159":"0855d1bc","392":"9958846c","730":"52f68deb"}[chunkId] + ".chunk.css");